import { useClient } from "@adamlip/okeoke.client"
import { useState, useContext } from "react"
import SelectLanguageModal from "components/SelectLanguageModal"
import { AppParamsContext } from "contexts/AppParamsContext"
import IconComponent from "components/IconComponent"

export default function LangElement({ size, sizes, textMax, text }) {
  const { languageCode, languages } = useClient()
  const { appParams } = useContext(AppParamsContext)
  const [languageModalOpen, setLanguageModalOpen] = useState(false)

  return (
    <>
      <SelectLanguageModal
        isOpen={languageModalOpen}
        onOpenChange={setLanguageModalOpen}
      />
      <div
        className={`transition-colors flex flex-col shrink-0 gap-1 h-full cursor-pointer`}
        onClick={() => setLanguageModalOpen(true)}
      >
        <div
          className={`mx-auto ${
            size != null ? sizes?.[size] : "w-[55px] h-[55px]"
          } ${
            appParams?.styles?.borderRadius?.navBar || "rounded-full"
          } !bg-[var(--top-bar-nav-bg-color)]`}
        >
          {appParams?.styles?.languages?.[
            languages?.[languageCode?.toUpperCase()]?.flagCode || "hu"
          ] ? (
            <IconComponent
              iconCode={
                appParams?.styles?.languages?.[
                  languages?.[languageCode?.toUpperCase()]?.flagCode || "hu"
                ]
              }
            />
          ) : (
            <img
              src={`https://cdn.okeoke.io/global/flags/${
                languages?.[languageCode?.toUpperCase()]?.flagCode || "hu"
              }.svg`}
              alt="enflag"
              className="w-full h-full"
            />
          )}
        </div>
        {text !== "hidden" && (
          <div
            className={`text-sm text-center truncate ${
              size != null ? textMax?.[size] : "max-w-[55px]"
            }`}
          >
            <div className="">
              {languages?.[languageCode?.toUpperCase()]?.name}
            </div>
          </div>
        )}
      </div>
    </>
  )
}
